import { SimpleButton } from "../../components/button.jsx/Btn";
import profilePlaceholder from "../../assets/profile-placeholder.svg";

export function AssetsView({ employees, onToggleView }) {
  return (
    <div>
      <div className="flex my-8 items-center justify-between">
        <div className="flex items-center gap-4">
          <h1 className="text-2xl font-semibold text-gray-900">Assets</h1>
          <button
            onClick={onToggleView}
            className="px-3 py-1 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
          >
            <span className="text-sm text-gray-600">Documents</span>
          </button>
        </div>
      </div>
      <div className="max-w-8xl bg-white mx-auto p-6 space-y-8">
        {/* Assets Section */}
        <div className="space-y-6">
          {/* Assign Tools Section */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-6">
              <h2 className="text-xl font-semibold text-gray-900">
                Assign Tools
              </h2>
              <button
                onClick={onToggleView}
                className="text-red-600 hover:text-red-800 text-sm font-medium"
              >
                All Folders
              </button>
            </div>
            <SimpleButton className="bg-blue-600 hover:bg-blue-700 text-white">
              All tools
            </SimpleButton>
          </div>

          {/* Employee Tools Table */}
          <div className="bg-white rounded-lg shadow-sm  overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr>
                    <th className="text-left py-3 px-6 text-sm font-medium text-gray-500">
                      Name
                    </th>
                    <th className="text-left py-3 px-6 text-sm font-medium text-gray-500">
                      Employee ID
                    </th>
                    <th className="text-left py-3 px-6 text-sm font-medium text-gray-500">
                      Email address
                    </th>
                    <th className="text-left py-3 px-6 text-sm font-medium text-gray-500">
                      Tools Assigned
                    </th>
                  </tr>
                </thead>
                {/* className="divide-y divide-gray-200" */}
                <tbody>
                  {employees.map((employee) => (
                    <tr
                      key={employee.id}
                      className="hover:bg-gray-50"
                    >
                      <td className="py-2 px-6">
                        <div className="flex items-center gap-3">
                          <img
                            src={employee.avatar || profilePlaceholder}
                            alt={employee.name}
                            className="w-8 h-8 rounded-full"
                          />
                          <span className="text-sm font-medium text-gray-900">
                            {employee.name}
                          </span>
                        </div>
                      </td>
                      <td className="py-4 px-6 text-sm text-gray-700">
                        {employee.employeeId}
                      </td>
                      <td className="py-4 px-6 text-sm text-gray-700">
                        {employee.email}
                      </td>
                      <td className="py-4 px-6 text-sm text-gray-700">
                        {employee.toolsAssigned}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
